'use client';

import { useMemo } from 'react';

import { useSearchFilter } from './use-search-filters.hook';

import { ScheduleSlotFilters } from '@/app/(main)/(pages)/_components/schedules/_hooks/use-schedule-slots.hook';
import { toSearchApiDayTime } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-day-time-api.util';

export function useSlotFilters(): ScheduleSlotFilters {
  const { filters } = useSearchFilter();

  return useMemo(
    () => ({
      dayTime: toSearchApiDayTime(filters.dayTime),
      minDate: filters.minDate,
      maxDate: filters.maxDate,
    }),
    [filters.dayTime, filters.minDate, filters.maxDate],
  );
}
